module.exports = __webpack_public_path__ + "static/media/OAuth2_algorithm.21b7583a.png";